import { render, staticRenderFns } from "./AhFooter.vue?vue&type=template&id=2830ac65&scoped=true&lang=pug&"
import script from "./AhFooter.vue?vue&type=script&lang=js&"
export * from "./AhFooter.vue?vue&type=script&lang=js&"
import style0 from "./AhFooter.vue?vue&type=style&index=0&id=2830ac65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830ac65",
  null
  
)

export default component.exports